module.exports = __webpack_public_path__ + "static/media/lista-use-procedure.f0539def.mp4";